import React from 'react';
import { Box, Typography } from '@mui/material';
import SectionContainer from './SectionContainer';
import { serviceCategories } from './content';

const TrustedBy = () => (
  <Box sx={{ bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : '#EFF4FF'), py: { xs: 5, md: 6 } }}>
    <SectionContainer sx={{ textAlign: 'center' }}>
      <Typography sx={{ fontWeight: 700, fontSize: 13, color: 'text.secondary', letterSpacing: 0.6, mb: 3 }}>
        TRUSTED BY MULTIPLE USERS TO TRACK
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: { xs: 1.5, md: 2 } }}>
        {serviceCategories.map(({ title, color, Icon }) => (
          <Box
            key={title}
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 2,
              py: 1,
              borderRadius: 999,
              bgcolor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : '#fff',
              border: '1px solid',
              borderColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.08)',
            })}
          >
            <Icon sx={{ fontSize: 18, color }} />
            <Typography sx={{ fontWeight: 600, fontSize: 13.5, whiteSpace: 'nowrap' }}>{title}</Typography>
          </Box>
        ))}
      </Box>
    </SectionContainer>
  </Box>
);

export default TrustedBy;
